export default __webpack_public_path__ + "static/media/bitmart.fc22a6a6.svg";